export const compressImage = (file: File, maxSizeMB: number = 5): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const base64String = event.target?.result as string;
      
      // If it's not an image (e.g., PDF) or if it's already smaller than maxSizeMB, return directly
      if (!file.type.startsWith('image/') || file.size <= maxSizeMB * 1024 * 1024) {
        resolve(base64String);
        return;
      }

      const img = new Image();
      img.src = base64String;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        // Initial quality
        let quality = 0.9;
        
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, width, height);
        
        let dataUrl = canvas.toDataURL('image/jpeg', quality);
        
        // Reduce size if needed
        // dataUrl.length is the length of the base64 string. 
        // Base64 string is roughly 4/3 of the file size.
        // So 2MB file is roughly 2.66MB in base64 string.
        const maxBase64Length = maxSizeMB * 1024 * 1024 * 1.33;
        
        while (dataUrl.length > maxBase64Length && quality > 0.1) {
          quality -= 0.1;
          dataUrl = canvas.toDataURL('image/jpeg', quality);
        }
        
        resolve(dataUrl);
      };
      img.onerror = reject;
    };
    reader.onerror = reject;
  });
};
